import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import SendMessage from "./pages/SendMessage";
import Chat from "./pages/Chat";
import SubmissionReportPage from "./pages/SubmissionReport";
import ChatReports from "./pages/ChatReports";
import ProtectedRoute from "./routes/ProtectedRoute";

function App() {
   console.log(Login, Dashboard, SendMessage, ProtectedRoute);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />

        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/send-message"
          element={
            <ProtectedRoute>
              <SendMessage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <Chat />
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports/messages"
          element={
            <ProtectedRoute>
              <SubmissionReportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports/chats"
          element={
            <ProtectedRoute>
              <ChatReports />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
